import { css } from "styled-system/css";

export const container = css({
  display: "flex",
  alignItems: "center",
  gap: "sm",
  cursor: "pointer",
  userSelect: "none",
});

export const input = css({
  appearance: "none",
  width: "1.25rem",
  height: "1.25rem",
  borderRadius: "4px",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  backgroundColor: "bgBase100",
  cursor: "pointer",
  transitionProperty: "background-color, border-color",
  transitionDuration: "0.2s",
  position: "relative",
  _checked: {
    backgroundColor: "primary",
    borderColor: "primary",
    _after: {
      content: '""',
      position: "absolute",
      left: "4px",
      top: "1px",
      width: "6px",
      height: "10px",
      borderWidth: "0 2px 2px 0",
      borderStyle: "solid",
      borderColor: "#ffffff",
      transform: "rotate(45deg)",
    },
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
});

export const label = css({
  fontFamily: "sans",
  fontSize: "sm",
  color: "textBase",
});
